module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "760px",
      "height": "100%",
      "overflow": "hidden",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [(_vm.toolbarShow) ? _c('iframe', {
    staticStyle: {
      "border": "0",
      "width": "100%",
      "height": "50px",
      "background": "#fff",
      "padding": "0 15px",
      "box-sizing": "border-box",
      "border-radius": "0 0 25px 25px"
    },
    attrs: {
      "id": "agpBox",
      "name": "agpBox",
      "src": _vm.agpHtmlUrl + '?source=demo'
    }
  }) : _vm._e(), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0",
      "width": "100%",
      "height": "500px",
      "position": "absolute",
      "left": "0",
      "top": "50px",
      "z-index": "9999",
      "display": "none",
      "padding": "0 15px",
      "box-sizing": "border-box"
    },
    attrs: {
      "id": "plugBox",
      "name": "plugBox",
      "src": _vm.plugHtmlUrl
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.Language('通讯录'),
      "visible": _vm.linkBookShow,
      "width": "400px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.linkBookShow = $event
      },
      "close": _vm.closeLinkBookFn
    }
  }, [_c('div', {
    staticClass: "pl-15 pr-15"
  }, [_c('div', {
    staticClass: "transfer_item radio_tree"
  }, [(_vm.linkBookOne) ? _c('el-radio-group', {
    staticClass: "w-100bf",
    model: {
      value: (_vm.checkPhone),
      callback: function($$v) {
        _vm.checkPhone = $$v
      },
      expression: "checkPhone"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.linkBookList,
      "node-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var data = ref.data;

        return _c('div', {}, [(data.isType == 1) ? _c('span', {
          staticClass: "font-14"
        }, [_vm._v(_vm._s(data.label))]) : _c('el-radio', {
          attrs: {
            "label": data
          }
        }, [_vm._v(_vm._s(data.label))])], 1)
      }
    }], null, false, 2010588046)
  })], 1) : _c('el-checkbox-group', {
    staticClass: "w-100bf",
    model: {
      value: (_vm.checkPhoneMore),
      callback: function($$v) {
        _vm.checkPhoneMore = $$v
      },
      expression: "checkPhoneMore"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.linkBookList,
      "node-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var data = ref.data;

        return _c('div', {}, [(data.isType == 1) ? _c('span', {
          staticClass: "font-14"
        }, [_vm._v(_vm._s(data.label))]) : _c('el-checkbox', {
          attrs: {
            "label": data
          }
        }, [_vm._v(_vm._s(data.label))])], 1)
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setLinkBook
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.closeLinkBookFn
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.Language(_vm.agentDialogTitle),
      "visible": _vm.agentShow,
      "width": "800px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.agentShow = $event
      },
      "close": _vm.closeAgentFn
    }
  }, [_c('div', {
    staticClass: "pl-15 pr-15 mb-15"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.Language('坐席组名称'),
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.agentGroupKey),
      callback: function($$v) {
        _vm.agentGroupKey = $$v
      },
      expression: "agentGroupKey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "transfer_item mt-0"
  }, [_c('el-table', {
    ref: "groupTable",
    attrs: {
      "data": _vm.agentGroupDataAll.filter(function (data) { return !_vm.agentGroupKey || data.groupName.includes(_vm.agentGroupKey); }),
      "border": "",
      "max-height": "400px",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.groupRowClickFn
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": _vm.Language('坐席组名称')
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.Language('工号或坐席名称'),
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.agentKey),
      callback: function($$v) {
        _vm.agentKey = $$v
      },
      expression: "agentKey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "transfer_item mt-0"
  }, [_c('el-table', {
    ref: "agentTable",
    attrs: {
      "data": _vm.showAgentData.filter(function (data) { return !_vm.agentKey || data.userName.includes(_vm.agentKey) || data.workNo.includes(_vm.agentKey); }),
      "border": "",
      "max-height": "368px",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.agentRowClickFn,
      "row-dblclick": _vm.agentRowDbClickFn
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "workNo",
      "label": _vm.Language('工号')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": _vm.Language('坐席名称')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "skillName",
      "label": _vm.Language('技能组名称')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.Language('状态')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 64) ? _c('span', {
          staticStyle: {
            "color": "#8b73ff"
          }
        }, [_vm._v(_vm._s(_vm.Language('振铃')))]) : _vm._e(), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#409EFF"
          }
        }, [_vm._v(_vm._s(_vm.Language('空闲')))])]
      }
    }])
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitAgentFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.agentShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "IVR列表",
      "visible": _vm.ivrShow,
      "width": "400px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ivrShow = $event
      },
      "close": _vm.closeIvrFn
    }
  }, [_c('div', {
    staticClass: "pl-15 pr-15 pb-5"
  }, [_c('el-table', {
    ref: "ivrTable",
    attrs: {
      "data": _vm.ivrList,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.ivrRowClickFn
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.Language('IVR名称')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "flowId",
      "label": _vm.Language('流程ID')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nodeId",
      "label": _vm.Language('节点ID')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.ivrPage,
      "page-size": 10,
      "total": _vm.ivrTotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.ivrPage = $event
      },
      "update:current-page": function($event) {
        _vm.ivrPage = $event
      },
      "current-change": _vm.getIvrListFn
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitIvrFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.ivrShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "技能列表 (转移至技能)",
      "visible": _vm.skillShow,
      "width": "400px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.skillShow = $event
      },
      "close": _vm.closeSkillFn
    }
  }, [_c('div', {
    staticClass: "pl-15 pr-15 pb-5"
  }, [_c('el-table', {
    ref: "skillTable",
    attrs: {
      "data": _vm.skillList,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.skillRowClickFn
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": _vm.Language('坐席组')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "skillName",
      "label": _vm.Language('技能')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.skillPage,
      "page-size": 10,
      "total": _vm.skillTotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.skillPage = $event
      },
      "update:current-page": function($event) {
        _vm.skillPage = $event
      },
      "current-change": _vm.getGroupSkillListFn
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitSkillFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.skillShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "保持找回",
      "visible": _vm.holdCallShow,
      "width": "800px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.holdCallShow = $event
      },
      "close": _vm.closeHoldCallFn
    }
  }, [_c('div', {
    staticClass: "pl-15 pr-15 pb-5"
  }, [_c('el-table', {
    ref: "holdCallTable",
    attrs: {
      "data": _vm.holdCallList,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.holdCallRowClickFn
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CallOfferedType",
      "label": _vm.Language('呼叫类型')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Caller",
      "label": _vm.Language('客户号码')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Called",
      "label": _vm.Language('热线号码/工号')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AgentGroupName",
      "label": _vm.Language('坐席组')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SkillName",
      "label": _vm.Language('技能')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CallData",
      "label": _vm.Language('呼叫数据')
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitHoldCallFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.holdCallShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "配置信息",
      "visible": _vm.startInfo,
      "width": "600px",
      "modal-append-to-body": false,
      "custom-class": "center-dialog setinfo-dialog",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.startInfo = $event
      },
      "close": function($event) {
        return _vm.closeBack('sForm')
      }
    }
  }, [_c('el-form', {
    ref: "sForm",
    staticClass: "new-form-center",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "model": _vm.sForm,
      "label-width": "110px",
      "rules": _vm.sRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('分机号'),
      "prop": "extNum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.Language('分机号'),
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.sForm.extNum),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "extNum", $$v)
      },
      expression: "sForm.extNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('文书时长'),
      "prop": "docTimeLong"
    }
  }, [_c('el-input-number', {
    staticClass: "mr-10",
    attrs: {
      "size": "small",
      "min": 1,
      "max": 9999,
      "step": 1,
      "step-strictly": "",
      "disabled": !_vm.GLOBAL.power.is_1040
    },
    model: {
      value: (_vm.sForm.docTimeLong),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "docTimeLong", $$v)
      },
      expression: "sForm.docTimeLong"
    }
  }), _vm._v("秒\n          ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('消息提示时长'),
      "prop": "msgTipTimeLong"
    }
  }, [_c('el-input-number', {
    staticClass: "mr-10",
    attrs: {
      "size": "small",
      "min": 1,
      "max": 9999,
      "step": 1,
      "step-strictly": "",
      "disabled": !_vm.GLOBAL.power.is_1042
    },
    model: {
      value: (_vm.sForm.msgTipTimeLong),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "msgTipTimeLong", $$v)
      },
      expression: "sForm.msgTipTimeLong"
    }
  }), _vm._v("秒\n          ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('小休时长'),
      "prop": "smallRestTimeLong"
    }
  }, [_c('el-input-number', {
    staticClass: "mr-10",
    attrs: {
      "size": "small",
      "min": 1,
      "max": 9999,
      "step": 1,
      "step-strictly": "",
      "disabled": !_vm.GLOBAL.power.is_1041
    },
    model: {
      value: (_vm.sForm.smallRestTimeLong),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "smallRestTimeLong", $$v)
      },
      expression: "sForm.smallRestTimeLong"
    }
  }), _vm._v("秒\n          ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('热线状态'),
      "prop": "ccState"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": !_vm.GLOBAL.power.is_1044
    },
    model: {
      value: (_vm.sForm.ccState),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ccState", $$v)
      },
      expression: "sForm.ccState"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "32"
    }
  }, [_vm._v(_vm._s(_vm.Language('空闲（已签入）')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v(_vm._s(_vm.Language('示忙')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4096"
    }
  }, [_vm._v(_vm._s(_vm.Language('离线')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('坐席组'),
      "prop": "ccGroupData"
    }
  }, [_c('el-select', {
    staticClass: "w-100bf",
    attrs: {
      "placeholder": _vm.Language('坐席组'),
      "clearable": "",
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.sForm.ccGroupData),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ccGroupData", $$v)
      },
      expression: "sForm.ccGroupData"
    }
  }, _vm._l((_vm.agentGroupData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.groupName,
        "value": item.groupId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('技能组'),
      "prop": "ccSkillData"
    }
  }, [_c('el-select', {
    staticClass: "w-100bf",
    attrs: {
      "placeholder": _vm.Language('技能组'),
      "clearable": "",
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.sForm.ccSkillData),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "ccSkillData", $$v)
      },
      expression: "sForm.ccSkillData"
    }
  }, _vm._l((_vm.skillGroupData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.skillName,
        "value": item.skillId
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.loginInitUpdateDataFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确 定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.startInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取 消')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d4b82836","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/RightPane/controlBox.vue
// module id = 1343
// module chunks = 5